module.exports = __webpack_public_path__ + "img/pdf.3523e067.png";